import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import Welcome from '../views/Welcome.vue';
import firebase from 'firebase';
Vue.use(VueRouter)

const routes = [
  {
    path:"*",
    redirect:"/"
  },
  {
    path: '/',
    name: 'welcome',
    component: Welcome
  },
  {
    path: '/home/:tab/',
    name: 'home',
    component: Home,
    meta: {
      requiresAuth : true
    }
  },
  {
    path: '/home',
    name: 'home-inicio',
    component: Home,
    meta: {
      requiresAuth : true
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: "/",
  routes
})

router.beforeEach((to, from, next)=> {
  const currentUser = firebase.auth().currentUser;
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

  if (requiresAuth && !currentUser) next('welcome');
  else if (!requiresAuth && currentUser) next('home');
  else next();
})

export default router;
